import { render, staticRenderFns } from "./Breeno.vue?vue&type=template&id=053bc60c&"
import script from "./Breeno.vue?vue&type=script&lang=js&"
export * from "./Breeno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports